import "./../../../../../assets/css/PatientDashboard.css";
import useTitanApp from "../../../../../hooks/useTitanApp";
import { useState, useMemo } from "react";
import { Dropdown } from "primereact/dropdown";
import { format } from "date-fns";
import Skeleton from "@mui/material/Skeleton";
import {
  setCurrentShowPatientReferralLetterModal,
  setReferralLetter,
} from "../../../../../dispatchers/patientDispatchers";

export default function ReferralLetters() {
  const { patientState, appState } = useTitanApp();
  const { patientConsultations, showPatientConsultationsLoader } = patientState;
  const { darkMode } = appState || {};

  const [selectedDays, setSelectedDays] = useState(null);

  const dayOptions = [
    { label: "All", value: "all" },
    { label: "Last 30 days", value: 30 },
    { label: "Last 20 days", value: 20 },
    { label: "Last 10 days", value: 10 },
  ];

  const referralLetters = useMemo(() => {
    return patientConsultations?.flatMap((consultation) =>
      (consultation?.actions || [])
        ?.filter(
          (action) =>
            action?.actionName === "SendReferralLetter" &&
            action?.actionNumber === "3"
        )
        ?.map((action) => ({
          action,
          createdOn: consultation.createdOn,
          consultationId: consultation.consultationId,
        }))
    );
  }, [patientConsultations]);

  const now = useMemo(() => new Date(), []);
  const refsByDate = useMemo(() => {
    if (!selectedDays || selectedDays === "all") return referralLetters;
    return referralLetters?.filter(({ createdOn }) => {
      const diffDays =
        (now.getTime() - new Date(createdOn).getTime()) / (1000 * 60 * 60 * 24);
      return diffDays <= selectedDays;
    });
  }, [referralLetters, selectedDays, now]);

  const handleViewReferralLetter = async (action) => {
    try {
      const outer = JSON.parse(action?.payload);
      const inner = JSON.parse(outer.payload);
      const { letterContent } = inner;

      setReferralLetter(letterContent);
      setCurrentShowPatientReferralLetterModal(true);
    } catch (err) {
      console.error("Failed to parse referral letter payload:", err);
    }
  };
  return (
    <div className="card-shaped-box">
      <div className="tasks_header">
        <div>
          <h3 className="pharmacy_header_name">
            Referral Letters {`(${refsByDate?.length ?? 0})`}
          </h3>
          <p className="mt-1 description">
            {selectedDays && selectedDays !== "all"
              ? `Showing referral letters from the last ${selectedDays} days`
              : "Showing all referral letters."}
          </p>
        </div>
        <div className="referral-selected-days">
          <Dropdown
            value={selectedDays}
            onChange={(e) => setSelectedDays(e.value)}
            options={dayOptions}
            optionLabel="label"
            optionValue="value"
            placeholder="Select Range"
            className="dropdown"
            panelClassName="bucket-dropdown-panel"
          />
        </div>
      </div>
      {showPatientConsultationsLoader ? (
        <div className="consultation-skeleton-wrapper">
          {[...Array(3)].map((_, i) => (
            <Skeleton
              key={i}
              sx={{
                bgcolor: darkMode ? "grey.800" : "",
                width: "100%",
                height: "70px",
                borderRadius: "16px",
                marginBottom: "10px",
                marginTop: "20px",
              }}
              variant="rounded"
            />
          ))}
        </div>
      ) : (
        <div className="referral-letter-content">
          <div className="referral-boxes">
            {!refsByDate || refsByDate.length === 0 ? (
              <p>No referral letters in this range.</p>
            ) : (
              refsByDate.map(({ action, createdOn }, i) => (
                <div
                  className="referral_box"
                  key={`${action?.actionNumber}-${i}`}
                  onClick={() => handleViewReferralLetter(action)}
                >
                  <div className="referral_letter"></div>
                  <div className="referral_desc">
                    <p>RF # {String(i + 1).padStart(7, "0")}</p>
                    <p>{format(new Date(createdOn), "dd/MM/yy, hh:mm a")}</p>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      )}
    </div>
  );
}
